import React from 'react';

function YoutubePlayer({ src = '', title = '' }) {
	return (
		<iframe
			width='100%'
			height='450'
			src={`${src}?modestbranding=1`}
			title={title}
			frameBorder='0'
			allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
			allowFullScreen
		></iframe>
	);
}

export default YoutubePlayer;
